import { useContext, useRef, useLayoutEffect } from "react";
import { Text } from "@aidron/aidron-ds";
import { TenantContext } from "../../../../templates/context/TenantContext";

import PropTypes from 'prop-types';
import { textFormatter } from "../../../../utils/formatter/formatter";

export function HierarchyBodyCells({ ctx, uiState }) {
  
  const { 
    productId,
    productRows,
    selectedHierarchyIndexes = [],
    allProducts
  } = ctx || {};

  const {
    freezeColumns,
    sumPreviousColumnsWidth,
    evaluateLastCategoryColumn,
    storesTable,
    setHierarchyColumnsWidth,
    salesTable = false
  } = uiState || {};

  const { hierarchy = {} } = useContext(TenantContext);
  
  const hierarchyRefs = useRef(null);

  const product = (allProducts ?? []).find((product) => product.productId === productId) || {};

  const defineHierarchyToDisplay = () => hierarchy?.levels.filter((level, index) => selectedHierarchyIndexes.includes(index)) || [];

  const getHierarchyRefs = () => {
    if (!hierarchyRefs.current) hierarchyRefs.current = new Map();
    return hierarchyRefs.current;
  }

  const defineHierarchyRefs = (node, level) => {
    const map = getHierarchyRefs();
    if (node) {
      map.set(level, node);
    } else {
      map.delete(level);
    }
  }

  const cellRightBorder = (index) => {
    return !freezeColumns && index === defineHierarchyToDisplay().length - 1
      ? "cell-right-border"
      : "";
  }; 

  useLayoutEffect(() => {

    const currentNodes = [...getHierarchyRefs().values()]
      .filter(Boolean);

    const updateColumnWidths = () => {
      setHierarchyColumnsWidth(
        currentNodes.map(n => n.getBoundingClientRect().width)
      );
    };

    updateColumnWidths();

    const observer = new ResizeObserver(updateColumnWidths);
    currentNodes.forEach(node => observer.observe(node));

    return () => observer.disconnect();
  }, [selectedHierarchyIndexes.join(','), salesTable, hierarchy,
      setHierarchyColumnsWidth]);  

  return (
    <>
      {defineHierarchyToDisplay().map((level, index) => (
        <td
          key={`level-${level}-index-${index}`}
          ref={(node) => defineHierarchyRefs(node, level)}
          className={`background-color-white ${salesTable ? "" : 'padding-sides-040rem'} ${evaluateLastCategoryColumn(index)} ${cellRightBorder(index)}`}
          style={{
            position: freezeColumns ? "sticky" : "",
            left: freezeColumns ? `${sumPreviousColumnsWidth(index + 1)}px` : "",
          }}
        >
          <div 
            className={storesTable && index === 0 ? "ps-4" : ""}
            style={{ 
              paddingInlineStart: salesTable ? "0rem" : "",
              whiteSpace: "nowrap"
            }}>
            <Text>{textFormatter(product[level]) || ""}</Text>
          </div>
        </td>
      ))}
    </>
  );
};

HierarchyBodyCells.propTypes = { ctx: PropTypes.shape(), uiState: PropTypes.shape() };